import React from "react"
import { Route, Redirect } from "react-router-dom"
import useUser from './hooks/useUser'

function PrivateRoute({ admin = false ,component: Component, ...rest }) {
  const { isLoggedIn, isAdmin } = useUser()
  const allowedAccess = admin ? isAdmin : isLoggedIn
  
  return (
    <Route {...rest}
      render={props =>
        allowedAccess
          ? <Component {...props} />
          : <Redirect to={!isLoggedIn ? '/login' : '/'} />
      }
    />
  );
}

export default PrivateRoute
